<template>
  <div class="bg-container page">
    <img class="bg-img" src="/img/login/login.jpg" onerror="this.src='/img/error.png'" />
    <div class="bg-wrapper">
      <div class="login">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="arrow-left" color="#fff" @click="back()" />
          </template>
          <template #right>
            <div class="language" @click="$router.push('/language')">
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
            </div>
          </template>
        </van-nav-bar>
        <div class="wrapper">
          <!-- Logo -->
          <div class="logo-container">
            <div class="logo-wrapper">
              <img class="logo-img" src="/img/login/logo.png" onerror="this.src='/img/error.png'" />
            </div>
          </div>

<!--          <div class="title">{{ $t("auth.login") }}</div>-->
          <div class="loginForm">
            <van-field
              v-model="username"
              clearable
              input-align="center"
              class="input"
              :placeholder="$t('auth.username_place')"
            />
            <van-field
              v-model="password"
              :type="passwordType"
              input-align="center"
              class="input"
              :placeholder="$t('auth.pwd_place')"
            >
              <template slot="right-icon">
                <van-icon
                  :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                  @click="switchPasswordType"
                />
              </template>
            </van-field>
            <div
              class="reset-text"
              role="button"
              tabindex="0"
              @click="toCustomerService"
              @keydown.enter="toCustomerService"
              @keydown.space.prevent="toCustomerService"
            >
              <span>{{$t("auth.forgetpwd")}}?</span>
            </div>
            <div @click="toRegister()" class="register-text">
              <span>{{$t("auth.no_account")}}</span>
            </div>
            <van-button
              class="login-btn"
              type="primary"
              size="normal"
              @click="doLogin()"
              >{{$t("auth.login")}}</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 在线客服 -->
    <div class="customer-service-btn" @click="toCustomerService()">
      <van-icon name="chat-o" color="#fff" size="28" />
    </div>
  </div>
</template>

<script>
import { getCurrentLang, setCurrentLang, syncLangWithBackend } from '../../common/lang';
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      username: '',
      lang: getCurrentLang(),
      password: this.inputValue,
      passwordType: "password",
    };
  },
  mounted() {
    const currentLang = setCurrentLang(getCurrentLang());
    this.lang = currentLang;
    syncLangWithBackend(this.$http, currentLang);
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    toCustomerService() {
      const service = this.$store.getters.getBaseInfo;
      if (service && service.iskefu == 1 && service.kefu) {
        window.location.href = service.kefu;
      } else {
        this.$router.push('/ServiceOnline');
      }
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "get",
        data: {
          username: this.username,
          password: this.password,
          // lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.login {
  height: 100%;
}
.bg-container .bg-wrapper .login .nav-bar {
  background: 0 0;
}

.language{
		position: absolute;
		top: 50%;
		right: 40px;
		transform: translateY(-50%);
		display: flex;
		align-items: center;

		img{
			height: 100%;
		}
	}

.login .wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.logo-container {
  margin: 0 auto;
  width: 45%;
}
.logo-container .logo-wrapper {
  position: relative;
  padding-bottom: 62.5%;
}
.logo-container .logo-wrapper .logo-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.login .wrapper .title {
  line-height: 100px;
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 5px;
}
.login .wrapper .loginForm {
  padding: 60px;
}
.login .wrapper .loginForm .input {
  padding: 10px 20px;
  margin-top: 40px;
  border-radius: 50px;
  text-align: center;
  line-height: 80px;
  font-size: 30px;
  color: #4e4e4e;
}
::v-deep .van-field__right-icon .van-icon {
  font-size: 50px;
}
::v-deep .van-icon {
  font-size: 50px;
}
.login .wrapper .loginForm .reset-text {
  margin: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
}
.login .wrapper .loginForm .reset-text:focus {
  outline: none;
}
.login .wrapper .loginForm .reset-text span {
  color: #ffd45a;
  font-size: 25px;
  font-weight: 500;
  line-height: 15px;
  text-decoration: underline;
  transition: opacity 0.2s ease;
}
.login .wrapper .loginForm .reset-text:hover span,
.login .wrapper .loginForm .reset-text:focus span {
  opacity: 0.85;
}
.login .wrapper .loginForm .register-text {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .wrapper .loginForm .register-text span {
  color: #fff;
  font-size: 25px;
  font-weight: 500;
  line-height: 20px;
}
.login .wrapper .loginForm .active {
}
.login .wrapper .loginForm .login-btn {
  margin-top: 85px;
  width: 100%;
  height: 100px;
  border-radius: 50px;
  color: #fff;
  background: linear-gradient(90deg, #d51aac, #cc2996);
  font-size: 30px;
  font-weight: bolder;
  border: none;
}
.customer-service-btn {
  position: fixed;
  bottom: 280px;
  right: 50px;
  width: 70px;
  height: 70px;
  background: linear-gradient(90deg, #d51aac, #cc2996);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  cursor: pointer;
  transition: all 0.3s ease;
}
.customer-service-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}
.customer-service-btn:active {
  transform: scale(0.95);
}
</style>

